import * as React from "react";
import type { SVGProps } from "react";
const SvgHotelBuilding = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#90A4AE"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M1.333 14h13.334"
    />
    <path
      stroke="#7E8796"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14 14V2.667A.667.667 0 0 0 13.333 2H6.667A.667.667 0 0 0 6 2.667V14M8 4.667h4M8 6.667h4M8 8.667h4M2 14V5.333c0-.368.298-.666.667-.666H6M11.333 14v-2.667M8.667 11.333V14M12 11.333H8"
    />
  </svg>
);
export default SvgHotelBuilding;
